/**
 * /send-campaigns — DEPRECATED.
 *
 * The FlowUpSender workspace was wiped on 2026-05-26 at the user's
 * request (clean slate for a new product line). The route now simply
 * redirects to /S.ADMIN so any stale bookmark / external link doesn't
 * 404.
 */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function SendCampaignsPage() {
  const navigate = useNavigate();
  useEffect(() => { navigate("/S.ADMIN", { replace: true }); }, [navigate]);
  return null;
}
